<!-- @format -->

<template>
	<div class="page_pdSty">
		<el-row>
			<el-col :span="24">
				<el-config-provider :locale="customPagination">
					<el-pagination
						:current-page="currentPage"
						:page-size="pageSize"
						:page-count="pageCount"
						:total="total"
						background
						v-bind="paginationOptions"
						class="pagination"
						style="justify-content: right"
						@size-change="handlePaginationSizeChange"
						@current-change="handlePaginationCurrentChange"
						@prev-click="handlePaginationPrevClick"
						@next-click="handlePaginationNextClick"
					>
						<div v-if="refreshable" class="refreshButton" @click="handleRefresh">
							<el-button :link="true" icon="RefreshRight"></el-button>
						</div>
					</el-pagination>
				</el-config-provider>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		props: {
			paginationOptions: {
				type: Object,
				default: () => {
					return {
						pagerCount: 5,
						pageSizes: [10, 20, 50, 100],
						layout: 'total, sizes, prev, pager, next',
					};
				},
			},
			// 总记录
			totalKey: {
				type: String,
				default: 'totalCount',
			},
			// 当前页数
			pageKey: {
				type: String,
				default: 'page',
			},
			// 分页大小
			pageSizeKey: {
				type: String,
				default: 'limit',
			},
			// 总页数
			pageCountKey: {
				type: String,
				default: 'totalPages',
			},
			// 表格分页数据
			pagination: {
				type: Object,
				default: () => {
					return {};
				},
			},
			// 是否开启刷新
			refreshable: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				customPagination: {
					el: {
						pagination: {
							pagesize: '条/页',
							total: '共 {total} 条',
							goto: '跳转至',
							pageClassifier: '页',
						},
					},
				},
			};
		},
		computed: {
			currentPage: {
				get() {
					return this.pagination[this.pageKey] || 1;
				},
				set(val) {
					this.handlePaginationCurrentChange(val);
				},
			},
			pageSize() {
				return this.pagination[this.pageSizeKey] || 20;
			},
			pageCount() {
				return this.pagination[this.pageCountKey];
			},
			total() {
				return Number(this.pagination[this.totalKey] || 0);
			},
		},
		methods: {
			// 每页条数改变
			handlePaginationSizeChange(pageSize) {
				this.handlePaginationChange({ [this.pageSizeKey]: pageSize, [this.pageKey]: 1 });
			},
			// 当前页码改变
			handlePaginationCurrentChange(currentPage) {
				this.handlePaginationChange({ [this.pageSizeKey]: this.pageSize, [this.pageKey]: currentPage });
			},
			// 上一页
			handlePaginationPrevClick() {
				// 备注：点击切换时多次调用接口，先注释掉
				// this.handlePaginationChange({[this.pageSizeKey]: this.pageSize,[this.pageKey]: currentPage})
			},
			// 下一页
			handlePaginationNextClick() {
				// 备注：点击切换时多次调用接口，先注释掉
				// this.handlePaginationChange({[this.pageSizeKey]: this.pageSize,[this.pageKey]: currentPage})
			},
			// 改变分页数据
			handlePaginationChange(params) {
				const pageSize = params[this.pageSizeKey];
				const currentPage = params[this.pageKey];

				if (pageSize === this.pageSize && currentPage === this.currentPage) {
					return;
				}
				this.$emit('change', {
					[this.pageSizeKey]: pageSize || this.pageSize,
					[this.pageKey]: currentPage || this.currentPage,
				});
			},
			// 刷新
			handleRefresh(e) {
				this.$emit('refresh', e);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.page_pdSty {
		padding: 10px 10px 10px 20px;
	}

	.totalSty {
		display: inline-block;
		margin-top: 8px;
		color: #1d2129;
		font-size: 14px;
	}
</style>
<style scoped>
	.pagination {
		justify-content: flex-end;
	}
</style>
